module.exports = __webpack_public_path__ + "img/about.226d8d02.jpg";